import React, { useEffect, useState } from "react";
import api from "../axiosInstance";

function useUniversitiesList({ universityId }) {
  const [universityList, setUniversityList] = useState([]);
  const [courses, setCourses] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [regulations, setRegulations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //   All UniversityList Api Fetching
  useEffect(() => {
    api
      .get("/getAllUniversities")
      .then((res) => setUniversityList(res.data.data))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);
  //   All CoursesList Api Fetching
  useEffect(() => {
    api
      .get(`/getCourses`, { params: { active: true } })
      .then((res) => setCourses(res.data.data))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);
  //   All SemestersList Api Fetching
  useEffect(() => {
    api
      .get(`/getSemesters`)
      .then((res) => setSemesters(res.data.data))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);
  //   All RegulationsList Api Fetching
  useEffect(() => {
    api
      .get(`/api/regulation-years`)
      .then((res) => setRegulations(res.data.data))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  return {
    universityList,
    courses,
    semesters,
    regulations,
    loading,
    error,
  };
}

export default useUniversitiesList;
